export class Message {
    constructor(
        public message: string,
        public open: string,
        public catId?: string,
        public catName?: string,
        public madeDate?: string,
        public senderName?: string,
        public receiver?: string,
        public sender?: string,
        public _kmd?,
        public _acl?,
        public _id?,

        
    ) { }
}
        
